import './VideoScriptStep.css';
import React, { useEffect, useState } from 'react';
import { VideoChooserWithImageOrIcons } from './VideoChooserWithImageOrIcons';
import { ReactComponent as LeftButtonChevron } from '../../../resources/icons/leftButtonChevron.svg';
import CarouselProvider from '../../atoms/CarouselProvider/CarouselProvider';
import { canUseDOM } from '../../../utils';
import { tealiumClickFuncWithOtherOptions, tealiumMergeClickData } from '../../../utils/tealium';
const VideoScriptStep = _ref => {
  let {
    rtl,
    setScriptStepData,
    title,
    scriptSteps,
    choiceItems,
    nextLabel,
    backLabel,
    onNextClick,
    onBackClick,
    currentStep,
    collectedData,
    navigationLeftIcon,
    navigationRightIcon,
    loginStatus,
    analytics,
    params
  } = _ref;
  const stepKey = scriptSteps[currentStep].key.jss.value;
  const selected = collectedData[stepKey] || [];
  const [mediaWidth992pxAndLess, setMediaWidth992pxAndLess] = useState(canUseDOM ? window.matchMedia('(max-width: 992px)').matches : false);
  useEffect(() => {
    if (canUseDOM) {
      window.addEventListener('resize', () => {
        setMediaWidth992pxAndLess(window.matchMedia('(max-width: 992px)').matches);
      });
    }
    return () => {
      if (canUseDOM) {
        window.addEventListener('resize', () => {
          setMediaWidth992pxAndLess(window.matchMedia('(max-width: 992px)').matches);
        });
      }
    };
  }, []);
  const renderItems = () => choiceItems.map(item => {
    const cardKey = item.cardKey;
    const isSelected = selected.includes(cardKey);
    return /*#__PURE__*/React.createElement(VideoChooserWithImageOrIcons, {
      key: item.id,
      id: item.id,
      rtl: rtl,
      title: item.title,
      svgIcon: item.svgIcon,
      image: item.image,
      isSelected: isSelected,
      onChange: () => setScriptStepData(stepKey, cardKey)
    });
  });
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onBackClick,
    className: "modal-bottom-panel__prev-btn"
  }, /*#__PURE__*/React.createElement(LeftButtonChevron, {
    className: "modal-bottom-panel__prev-btn-icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "modal-bottom-panel__prev-btn-title"
  }, backLabel)), mediaWidth992pxAndLess ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "journey-step__title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "journey-step__chooser"
  }, renderItems()), /*#__PURE__*/React.createElement("button", {
    disabled: selected.length === 0,
    className: "btn btn-primary marginTop",
    onClick: () => {
      onNextClick();
      const chosenTitle = choiceItems.filter(item => selected.includes(item.cardKey)).map(el => el.title);
      const analyticStr = `step ${currentStep + 1} : ${nextLabel} : ${chosenTitle}`;
      tealiumClickFuncWithOtherOptions(tealiumMergeClickData(analytics['NextButtonClickAnalytics'], params), analyticStr, {
        login_status: loginStatus ? 'logged in' : 'logged out'
      });
    }
  }, navigationLeftIcon ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: navigationLeftIcon
    }
  }) : null, /*#__PURE__*/React.createElement("span", {
    className: "buttonNextLabel"
  }, nextLabel), navigationRightIcon ? /*#__PURE__*/React.createElement("span", {
    className: "iconRight",
    dangerouslySetInnerHTML: {
      __html: navigationRightIcon
    }
  }) : null)) : /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      className: "container carousel-padding"
    }, /*#__PURE__*/React.createElement("div", {
      className: "wrapTextAndButtons"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "journey-step__title"
    }, title), /*#__PURE__*/React.createElement("div", {
      className: "pagination__btn"
    }, renderPreviousButton(), renderNextButton())), /*#__PURE__*/React.createElement("div", {
      className: "renderCarouselWrapper"
    }, renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 992
          },
          items: 4
        },
        mobile: {
          breakpoint: {
            max: 991,
            min: 0
          },
          items: 3
        }
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "ctaLinkWithPagination"
    }, /*#__PURE__*/React.createElement("button", {
      disabled: selected.length === 0,
      className: "btn btn-primary",
      onClick: () => {
        onNextClick();
        const chosenTitle = choiceItems.filter(item => selected.includes(item.cardKey)).map(el => el.title);
        const analyticStr = `step ${currentStep + 1} : ${nextLabel} : ${chosenTitle}`;
        tealiumClickFuncWithOtherOptions(tealiumMergeClickData(analytics['NextButtonClickAnalytics'], params), analyticStr, {
          login_status: loginStatus ? 'logged in' : 'logged out'
        });
      }
    }, navigationLeftIcon ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: navigationLeftIcon
      }
    }) : null, /*#__PURE__*/React.createElement("span", {
      className: "buttonNextLabel"
    }, nextLabel), navigationRightIcon ? /*#__PURE__*/React.createElement("span", {
      className: "iconRight",
      dangerouslySetInnerHTML: {
        __html: navigationRightIcon
      }
    }) : null), /*#__PURE__*/React.createElement("div", {
      className: `pagination-dot paginationWithButton`
    }, renderDots())));
  }));
};
VideoScriptStep.displayName = "VideoScriptStep";
export { VideoScriptStep };
const commonStyles = "c1sckxf7";
const rtlStyles = "r86wl8y";
const ltrStyles = "l9t3paw";